import { shallowMount } from "@vue/test-utils";
import Cliente from "@/views/Cliente";

describe("Cliente component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Cliente);
  });

  it("Renders del component Cliente", () => {
    expect(wrapper).toBeDefined();
  });
});
